module.exports = __webpack_public_path__ + "static/media/practice-cross-link.c1e459a7.png";